export const SET_LEARNSET = 'setLearnset';
export const UPDATE_LEARNSET = 'updateLearnset';
export const RESET_PROGRESS_LEARNSET = 'resetProgressLearnset';
export const SET_LEARNSET_FROM_ID = 'setLearnsetFromId';
export const PUSH_LEARNSET = 'pushLearnset';
export const RESET_LEARNSET = 'resetLearnset';
export const DELETE_LEARNSET = 'deleteLearnset';
export const KNOWN_CARD = 'knownCard';
export const UNKNOWN_CARD = 'unknownCard';
